import type { ReceiptTemplate } from '../schema';

export const hobbyLobbyTemplate: ReceiptTemplate = {
  id: 'hobby-lobby',
  name: 'Hobby Lobby Receipt',
  brand: 'HOBBY LOBBY',
  description: 'Hobby Lobby arts and crafts receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'hl-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/hobby-lobby.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hl-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hl-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'ACRYLIC PAINT SET', quantity: '1', price: '24.99', sku: '847291034' },
          { id: '2', name: 'CANVAS 16X20', quantity: '2', price: '12.99', sku: '847291035' },
          { id: '3', name: 'PAINT BRUSHES 10PK', quantity: '1', price: '9.99', sku: '847291036' },
          { id: '4', name: 'EASEL TABLETOP', quantity: '1', price: '19.99', sku: '847291037' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hl-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '80.95', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '6.68', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '87.63', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hl-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hl-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns within 90 days\nwith receipt\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

